/**
 * 用户相关 API
 */

import { authenticatedFetch } from './auth';
import { appConfig } from '../config';

// 类型定义
export interface UserInfo {
  id: number;
  nickname: string;
  avatar: string;
  mobile: string;
  sex: number;
  point: number;        // 积分
  experience: number;
  level: number | null;
  brokerageEnabled: boolean | null;
}

export interface UserInfoResponse {
  code: number;
  msg: string;
  data: UserInfo;
}

/**
 * 获取当前用户信息
 */
export const getUserInfo = async (): Promise<UserInfoResponse> => {
  const response = await authenticatedFetch(
    `${appConfig.api.baseUrl}/member/user/get`,
    {
      method: 'GET',
    }
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

